import { render, staticRenderFns } from "./StatsDashboard.vue?vue&type=template&id=f84f4f00&scoped=true"
import script from "./StatsDashboard.vue?vue&type=script&lang=js"
export * from "./StatsDashboard.vue?vue&type=script&lang=js"
import style0 from "./StatsDashboard.vue?vue&type=style&index=0&id=f84f4f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84f4f00",
  null
  
)

export default component.exports